/* eslint-disable react/prop-types */
import { Table as AntdTable } from "antd";
import { useState, useEffect } from "react";
import _ from "lodash";
import SearchBox from "../Inputs/SearchInput";

export function Table({
  rows,
  columns,
  filterby = "name",
  pageSize = 10,
  isSearchable = false,
  isPaginable = true,
  extra = null,
  pageNumber = null,
  setPageNumber = null,
  rowSelection = false,
  loading = false,
  expandable = false,
}) {
  const [filteredData, setFilteredData] = useState(rows);
  const [searchTerm, setSearchTerm] = useState("");

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: pageSize,
      total: rows?.length,
      showSizeChanger: true,
      pageSizeOptions: ["5", "10", "20", "50", "100"],
    },
  });

  // Handle search input changes
  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
    const filteredRows = rows.filter((row) =>
      row[filterby].toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredData(filteredRows);

    // Update pagination after search
    setTableParams((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        total: filteredRows.length,
        current: 1, // Reset to first page after filtering
      },
    }));
  };

  useEffect(() => {
    // If search term is empty, show all rows
    if (!searchTerm) {
      setFilteredData(rows);
      setTableParams((prev) => ({
        ...prev,
        pagination: { ...prev.pagination, total: rows?.length },
      }));
    }
  }, [rows, searchTerm]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    if (pageNumber) {
      setPageNumber(pagination.current);
    }
  };

  return (
    <div className="bg-white overflow-hidden">
      <div
        className={`flex items-center justify-between ${
          extra && "bg-white px-3 py-2 border-b-[1px] border-gray-100"
        } px-2 bg-[#fafafa]`}
      >
        {extra}
        {isSearchable && (
          <div className="ml-auto mb-4 mt-4">
            <SearchBox
              name={"search-table"}
              placeholder={`Search...`}
              onChange={(event) => handleSearch(event.target.value)} // Handle search input
            />
          </div>
        )}
      </div>

      {/* <div className="overflow-x-auto"> */}
      <div className="">
        <AntdTable
          loading={loading}
          pagination={isPaginable ? tableParams.pagination : false}
          rowKey={(record) => record.key}
          onChange={handleTableChange}
          columns={columns}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "bg-white" : "bg-zinc-50/50"
          }
          className="custom-ant-table"
          rowSelection={rowSelection}
          expandable={expandable}
          dataSource={_.cloneDeep(filteredData)}
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
}

export default Table;
